import { Box } from '@mui/material';
import { GridFilterInputValueProps, GridFilterItem, useGridRootProps } from '@mui/x-data-grid-pro';
import { useEffect, useRef, useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const timeOffset = new Date().getTimezoneOffset() * 60000;

export const applyFilter = (filterItem: GridFilterItem) => {
  if (!filterItem.value) {
    return null;
  }
  const startOfDay = new Date(new Date(filterItem.value).setHours(0, 0, 0, 0) + timeOffset).getTime();
  const endOfDay = new Date(new Date(filterItem.value).setHours(23, 59, 59, 999) + timeOffset).getTime();
  return (value: number): boolean => {
    return value != null && startOfDay <= value && value <= endOfDay;
  };
};

export const DatePickerInput = (props: GridFilterInputValueProps) => {
  const rootProps = useGridRootProps();
  const { item, applyValue } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterTimeout = useRef<any>(undefined);
  const [filterValueState, setFilterValueState] = useState<string | null>(item.value ?? '');

  useEffect(() => {
    return () => {
      clearTimeout(filterTimeout.current);
    };
  }, []);

  useEffect(() => {
    const itemValue = item.value ?? null;
    setFilterValueState(itemValue);
  }, [item.value]);

  const updateFilterValue = (date: string | null) => {
    clearTimeout(filterTimeout.current);
    setFilterValueState(date);

    filterTimeout.current = setTimeout(() => {
      applyValue({ ...item, value: date });
    }, rootProps.filterDebounceMs);
  };

  const handleLowerFilterChange = (date: string) => {
    let newDate = new Date(date);
    newDate = new Date(newDate.getTime() - timeOffset);
    updateFilterValue(newDate.toISOString());
  };

  let currentFilterValue = new Date(filterValueState || '');
  currentFilterValue = new Date(currentFilterValue.getTime() + timeOffset);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'end',
        height: '3rem',
        width: '25rem',
        pl: '1rem'
      }}>
      <DatePicker
        value={currentFilterValue}
        onChange={(newValue) => handleLowerFilterChange(String(newValue))}
        slotProps={{ actionBar: { actions: ['today'] }, textField: { size: 'small' } }}
        sx={{ mr: 2, mt: 2 }}
      />
    </Box>
  );
};
